import Modifier from 'ember-modifier';

// @ts-ignore
import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';

// Props to https://github.com/jelhan/ember-autoresize-modifier

interface IArgs {
  positional: [string, boolean];
  named: {};
}

export default class AutoresizeModifier extends Modifier<IArgs> {
  elementToResize: HTMLElement | null = null;
  disabled = false;
  constructor(owner: any, args: IArgs) {
    super(owner, args);

    registerDestructor(this, () => {
      this.elementToResize?.removeEventListener('input', this.onInput);
    });
  }

  modify(element: HTMLElement, positional: [string, boolean]): void {
    this.resize(element, positional?.[1]);
  }

  @action
  onInput() {
    this.resize(this.elementToResize, this.disabled);
  }

  @action
  resize(element: HTMLElement | null, disabled: boolean = false) {
    if (!element) {
      return;
    }
    this.elementToResize = element;
    this.disabled = disabled;

    // height must be calculated independently from height previously enforced
    this.elementToResize.style.height = 'auto';

    const isBorderBox = window.getComputedStyle(this.elementToResize).boxSizing === 'border-box';
    let requiredHeight = this.elementToResize.scrollHeight;

    if (isBorderBox) {
      // borders must be added on top of scrollHeight if box-sizing is border-box
      const borderHeight = this.elementToResize.offsetHeight - this.elementToResize.clientHeight;
      requiredHeight += borderHeight;
    }

    this.elementToResize.style.height = `${requiredHeight}px`;

    if (!this.disabled) {
      // resize on every input event
      this.elementToResize.addEventListener('input', this.onInput);
    }
  }
}
